<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-more`]" width="1em" height="1em" v-bind="$attrs"><path d="M4.08887 6.91016C4.68976 6.91041 5.17676 7.39808 5.17676 7.99902C5.1765 8.59976 4.6896 9.08666 4.08887 9.08691C3.48792 9.08691 3.00025 8.59991 3 7.99902C3 7.39792 3.48776 6.91016 4.08887 6.91016ZM8 6.91016C8.60096 6.91033 9.08789 7.39802 9.08789 7.99902C9.08764 8.59981 8.6008 9.08674 8 9.08691C7.39905 9.08691 6.91139 8.59991 6.91113 7.99902C6.91113 7.39792 7.39889 6.91016 8 6.91016ZM11.9111 6.91016C12.5122 6.91016 13 7.39792 13 7.99902C12.9997 8.59991 12.5121 9.08691 11.9111 9.08691C11.3102 9.08685 10.8235 8.59987 10.8232 7.99902C10.8232 7.39796 11.3101 6.91022 11.9111 6.91016Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineMore',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
